import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMatchBreakpoints } from '../customHooks/useMatchBreakpoints';
const BreakpointContext = /*#__PURE__*/React.createContext(null);
export function BreakpointProvider(props) {
  const {
    children
  } = props;
  const {
    matchedBreakpoints
  } = useMatchBreakpoints();
  const contextValues = useMemo(() => ({
    matchedBreakpoints
  }), [matchedBreakpoints]);
  return /*#__PURE__*/React.createElement(BreakpointContext.Provider, {
    value: contextValues
  }, children);
}
BreakpointProvider.propTypes = {
  children: PropTypes.node
};
export function useBreakpointContext() {
  const context = useContext(BreakpointContext);
  if (context === undefined) {
    throw new Error('To be used within the contet of NaosProvider');
  }
  return context;
}